import React, { useState } from 'react';
import styles from './MetricCard.module.scss';

export interface MetricCardProps {
  title: string;
  value: string;
  unit: string;
  percentage?: number;
  range?: string;
  icon?: React.ReactNode;
  color?: 'yellow' | 'purple' | 'green' | 'orange';
  status?: 'ok' | 'warning' | 'danger';
  showPercentage?: boolean;
  showIcon?: boolean;
  tooltip?: string;
}

export default function MetricCard({
  title,
  value,
  unit,
  percentage = 0,
  range,
  icon,
  color,
  status,
  showPercentage = true,
  showIcon = true,
  tooltip
}: MetricCardProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  
  // Déterminer la couleur à utiliser : priorité au status, sinon color
  const displayColor = status || color || 'green';
  
  return (
    <div 
      className={styles.metricCard}
      onMouseEnter={() => tooltip && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div className={styles.header}>
        {showIcon && icon && (
          <div className={styles.icon}>
            {icon}
          </div>
        )}
        <h3 className={styles.title}>{title}</h3>
      </div>
      
      <div className={styles.content}>
        {showPercentage && (
          <div className={`${styles.circularProgress} ${styles[`circularProgress--${displayColor}`]}`}>
            <div className={styles.progressCircle}>
              <div 
                className={styles.progressArc}
                style={{
                  background: `conic-gradient(var(--${displayColor}-color) ${percentage * 3.6}deg, #e5e7eb 0deg)`
                }}
              />
              <div className={styles.percentage}>{percentage}%</div>
            </div>
          </div>
        )}
        
        <div className={styles.valueContainer}>
          <div className={`${styles.value} ${styles[`value--${displayColor}`]}`}>
            {value}<span className={styles.unit}>{unit}</span>
          </div>
          <div className={styles.range}>{range}</div>
        </div>
      </div>
      
      {tooltip && showTooltip && (
        <div className={styles.tooltip}>
          {tooltip}
        </div>
      )}
    </div>
  );
}
